import React, { Component } from 'react';

export class MarkersPositioning extends Component {
  componentDidMount() {
    const client = localStorage.getItem('client');
    let pdfPath = '../assets/markersPositioning.pdf';

    if (client === 'POLAND' || client === 'POLAND_HAIL' || client === 'POLAND_GD') {
      pdfPath = '../assets/polish/markersPositioning.pdf';
    }

    const a = document.createElement('a');
    a.target = '_blank';
    a.href = pdfPath;
    a.click();

    window.location.pathname = '/dashboard';
  }

  render() {
    return null;
  }
}

export default MarkersPositioning;
